<template>
    <div class="login">
        <div class="content">
            <van-field
                v-model="phone"
                clearable
                label-width= 90
                label="手机号码"
                placeholder="请输入手机号"
                size="medium"
                class="inputVant"
            />
<!--            <van-field-->
<!--                v-model="name"-->
<!--                clearable-->
<!--                label-width= 90-->
<!--                label="用户姓名"-->
<!--                placeholder="请输入姓名"-->
<!--                size="medium"-->
<!--                class="inputVant"-->
<!--            />-->
            <van-field
                v-model="verification"
                label-width= 90
                size="medium"
                class="inputVant"
                center
                clearable
                label="短信验证码"
                placeholder="请输入短信验证码"
            >
                <van-button slot="button" size="medium" v-show="show" @click="getdata()" type="primary">发送验证码</van-button>
                <div  class="btnInfo"  v-show="!show" slot="button">{{count}}</div>
                
            </van-field>

            <div class="boreder"></div>
        </div>
        <div class="btn" @click="Submission()">完 成</div>
    </div>
</template>
<script>
import { Field, Button, Notify } from 'vant';
import { sendSms, getCustomerInfo, customerLogin } from '@/api/index';
export default {
    components:{
        [Field.name] : Field,
        [Button.name] : Button,
        [Notify.name] : Notify,
    },
    data(){
        return {
            phone: '',
            verification: '',
            show: true,
            count: '',
            timer: null,
            codes: 0,
            name: ''
        }
    },
    methods:{
        getdata(){
            if(this.phone === '') {
                Notify({message: '手机号格式不正确',duration: 1000,background: '#F54032',className:'tctab'});
                return ;
            // } else if(this.name === '') {
            //     Notify({message: '用户名不能为空',duration: 1000,background: '#F54032'});
            } else {
                sendSms({phone: this.phone, dataType: 0, name: this.name}).then(res=>{
                    this.show = false;
                    this.getCode();
                    this.codes = res.data;
                }).catch(error=>{

                })
            }
        },
           getCode(){
            const TIME_COUNT = 60;
            if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                }
            }, 1000)
            }
        },
        Submission(){
            if (this.verification == '' ){
                Notify({message: '验证码不能为空',duration: 1000,background: '#F54032',className:'tctab'});
                return false;
            }
            if(this.verification == this.codes){
                this.getInfo();
            }else {
                Notify({message: '验证码输入错误',duration: 1000,background: '#F54032',className:'tctab'});
            }
        },
        getInfo(){
            console.log(1234567);
            customerLogin({phone: this.phone, code: this.verification}).then(res=>{
                console.log(res.data);
                if(res.data != null){
                this.$loca.setItem('phone', this.phone );
                this.$loca.setItem('name', res.data.customerName );
                this.$router.push({path: '/'});
                }else {
                    Notify({message: res.message,duration: 1000,background: '#F54032',className:'tctab'});
                }
            }).catch(error=>{

            })
        }  
    }
}
</script>
<style lang="scss" scoped>
.login{
    width: 100vw;
    height: 100%;
    .van-button{
        height: 22px;
    }
    // background: #f6f6f6;
    .content{
        // border-bottom: 1px solid #ebedf0;
        .inputVant{
            line-height: 71px;
            align-items:center;
            position: relative;
            .btnInfo{
               position: absolute;
               right: 0;
               top: 0;
            }
        }
    }
    .btn{
        margin:0 auto;
        margin-top: 20%;
        width:616px;
        height:88px;
        background:rgba(0,183,238,1);
        border-radius:10px;
        color: #ffffff;
        font-size: 40px;
        line-height: 88px;
        text-align: center;
    }
}
</style>

